import { ApiError, createRole, updateRole } from "@/lib/api/client";
import type { RoleCreatePayload, RoleUpdatePayload } from "@/lib/api/types";

export type MasterResult = { error: string; violations: string[] } | undefined;

export async function createRoleAction(payload: RoleCreatePayload): Promise<MasterResult> {
  try {
    await createRole(payload);
  } catch (error) {
    if (error instanceof ApiError) return { error: error.message, violations: error.violations };
    return { error: "Unexpected error creating the role.", violations: [] };
  }
  return undefined;
}

export async function updateRoleAction(
  id: string,
  payload: RoleUpdatePayload,
): Promise<MasterResult> {
  try {
    await updateRole(id, payload);
  } catch (error) {
    if (error instanceof ApiError) return { error: error.message, violations: error.violations };
    return { error: "Unexpected error saving the role.", violations: [] };
  }
  return undefined;
}
